// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 5-12-2019 10:00:00 AM
// File Created Date      : 5-12-2019 10:00:00 AM

export default {
    namespaced: true,
    //#. An object containing the data
    state: {
        rolemenuheaders: [],
        menus: [],
        selected: [],
        selectAll: false,
        multiColumn: 3,
        componentKeyId: 0,
        wfPermissionId: 0,
        stepMappingDialog:false,
        inlineEditor: {
           enabled: true,
           autoSave: true,
           emptyRow: true
        },
        parentComponent: true,
        dialog:false,
        card: {
            type: 'Grid'
        },
        redirect: {
            menuId: 48,
            action: '/Admin/System/WorkFlowDefinition/WorkFlowStepMapping'
        },
        
        actions: {
            listAction: "/api/WorkFlowPermission/List/",
            deleteAction: "/api/WorkFlowPermission/",
            updateAction: "/api/WorkFlowPermission",
            createAction: "/api/WorkFlowPermission",
            //searchAction: "/api/Client/GetClientDetail/"
        },

        fields: {
            WorkFlowPermissionId: {
                primaryKey: true,
            },
            Service: {
                type: "Hidden"               
            },
            UserGroupsId: {
                required: true,
                type: "ComboBox",
                autocomplete: true,
                sortable: true,
                title: "User Group",
                redirect: {
                    menuId: 48,
                    action: '/Admin/System/WorkFlowDefinition/WorkFlowStepMapping'
                }
            },
            StepMapping: {
                prepend: true,
                type: "button",
                icon: "mdi-lock-reset",
                size: "20",
                color: "#557fb5",
                method: "getStepMapping"
            },
            CreatedById: {
                type: "Hidden"
            },
            CreatedDate: {
                type: "Hidden"
            },
            UpdatedById: {
                type: "Hidden"
            },
            UpdatedDate: {
                type: "Hidden"
            },
            SysSchemaId: {
                type: "Hidden"
            },
            SysJSON: {
                type: "Hidden"
            },
            CusSchemaId: {
                type: "Hidden"
            },
            CusJSON: {
                type: "Hidden"
            },
            OriginBusinessUnitId: {
                type: "Hidden"
            },
            
            ERSchemaId: {
                type: "Hidden"
            },
            EligibilityRule: {
                type: "Hidden"
            },
            StepHierarchy: {
                type: "Hidden"
            },
            WorkFlowDefinitionId: {
                parent: true
            },
            EligibilityRulesButton: {
                type: "Hidden"
            },
        },
    },
    //#. Used to access data from the state tree of the store
    getters: {},

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
            //  payload.payload.dashboard.componentId = 1;
        },
        formUpdated(state, payload) { },
        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },

        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        },
        //#. fn_selectionChanged function
        selectionChanged(state, context) {

        },
        getStepMapping(state, context) {
            context.rootState.workFlowPermissionIndex.stepMappingDialog = true;
            context.rootState.workFlowPermissionIndex.wfPermissionId = context.payload.item.WorkFlowPermissionId;
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },
        formUpdated: ({ commit, rootState }, payload) => {
            commit('formUpdated', { rootState, payload });
        },
        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
        //#. loadingRecords event will be fired
        loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },

        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },
        selectionChanged: ({ commit, rootState }, payload) => {
            commit('selectionChanged', { rootState, payload });
        },
        getStepMapping: ({ commit, rootState }, payload) => {

            commit('getStepMapping', { rootState, payload });
        },
    }
}